export const SNACKBAR_ACTIONS = {
  SHOW_WITH_MESSAGE: 'SNACKBAR_ACTIONS/SHOW_WITH_MESSAGE',
  DISMISS: 'SNACKBAR_ACTIONS/DISMISS',
}
